import { render } from "./ReportSalesVendor.vue?vue&type=template&id=dd8c1052&scoped=true"
import script from "./ReportSalesVendor.vue?vue&type=script&lang=js"
export * from "./ReportSalesVendor.vue?vue&type=script&lang=js"

import "./ReportSalesVendor.vue?vue&type=style&index=0&id=dd8c1052&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8c1052"]])

export default __exports__